// API URL configuration - uses environment variable or local development
export const API_URL = process.env.NODE_ENV === 'development'
  ? (process.env.REACT_APP_API_URL_DEVELOPMENT || process.env.REACT_APP_API_URL || 'http://localhost:15001/api')
  : (process.env.REACT_APP_API_URL || 'https://daileyhr.com/api');